import { useContext } from 'react';
import { LanguageContext } from "../contexts/LanguageContext"

function useLanguage() {
    const { selectedLanguage } = useContext(LanguageContext);
    return selectedLanguage;
}

export default useLanguage